export default {
    prefix: null,
    job_title: null,
    best_contact_time: null,
};
